var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _keysInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/keys");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/filter");

var _reduceInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/reduce");

var _sliceInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/slice");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/for-each");

var _indexOfInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/index-of");

var _concatInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/concat");

var _mapInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/map");

var _reverseInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/reverse");

var _spliceInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/splice");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs3/regenerator", "@babel/runtime-corejs3/core-js/instance/splice", "@babel/runtime-corejs3/helpers/classCallCheck", "@babel/runtime-corejs3/helpers/createClass", "@babel/runtime-corejs3/core-js/parse-float", "@babel/runtime-corejs3/core-js/instance/reverse", "@babel/runtime-corejs3/core-js/instance/map", "@babel/runtime-corejs3/core-js/instance/concat", "@babel/runtime-corejs3/core-js/instance/index-of", "@babel/runtime-corejs3/core-js/instance/for-each", "@babel/runtime-corejs3/helpers/toConsumableArray", "@babel/runtime-corejs3/helpers/asyncToGenerator", "@babel/runtime-corejs3/core-js/instance/slice", "@babel/runtime-corejs3/core-js/object/assign", "@babel/runtime-corejs3/core-js/array/is-array", "@babel/runtime-corejs3/core-js/instance/reduce", "@babel/runtime-corejs3/helpers/objectSpread", "@babel/runtime-corejs3/core-js/instance/filter", "@babel/runtime-corejs3/core-js/object/keys", "@babel/runtime-corejs3/helpers/typeof", "pako", "./rule", "js-cookie", "./constant"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs3/regenerator"), require("@babel/runtime-corejs3/core-js/instance/splice"), require("@babel/runtime-corejs3/helpers/classCallCheck"), require("@babel/runtime-corejs3/helpers/createClass"), require("@babel/runtime-corejs3/core-js/parse-float"), require("@babel/runtime-corejs3/core-js/instance/reverse"), require("@babel/runtime-corejs3/core-js/instance/map"), require("@babel/runtime-corejs3/core-js/instance/concat"), require("@babel/runtime-corejs3/core-js/instance/index-of"), require("@babel/runtime-corejs3/core-js/instance/for-each"), require("@babel/runtime-corejs3/helpers/toConsumableArray"), require("@babel/runtime-corejs3/helpers/asyncToGenerator"), require("@babel/runtime-corejs3/core-js/instance/slice"), require("@babel/runtime-corejs3/core-js/object/assign"), require("@babel/runtime-corejs3/core-js/array/is-array"), require("@babel/runtime-corejs3/core-js/instance/reduce"), require("@babel/runtime-corejs3/helpers/objectSpread"), require("@babel/runtime-corejs3/core-js/instance/filter"), require("@babel/runtime-corejs3/core-js/object/keys"), require("@babel/runtime-corejs3/helpers/typeof"), require("pako"), require("./rule"), require("js-cookie"), require("./constant"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, _spliceInstanceProperty2(global), global.classCallCheck, global.createClass, global.parseFloat, _reverseInstanceProperty2(global), _mapInstanceProperty2(global), _concatInstanceProperty2(global), _indexOfInstanceProperty2(global), _forEachInstanceProperty2(global), global.toConsumableArray, global.asyncToGenerator, _sliceInstanceProperty2(global), global.assign, global.isArray, _reduceInstanceProperty2(global), global.objectSpread, _filterInstanceProperty2(global), _keysInstanceProperty(global), global._typeof, global.pako, global.rule, global.jsCookie, global.constant);
    global.utils = mod.exports;
  }
})(this, function (_exports, _regenerator, _splice, _classCallCheck2, _createClass2, _parseFloat2, _reverse, _map, _concat, _indexOf, _forEach, _toConsumableArray2, _asyncToGenerator2, _slice, _assign, _isArray, _reduce, _objectSpread2, _filter, _keys, _typeof2, _pako, _rule, _jsCookie, _constant) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.isObject = isObject;
  _exports.isPlainObject = isPlainObject;
  _exports.hash = hash;
  _exports.getUUID = getUUID;
  _exports.parseDomain = parseDomain;
  _exports.getDeviceId = getDeviceId;
  _exports.customerErrorCheck = customerErrorCheck;
  _exports.gzip = gzip;
  _exports.ifReportHttpError = ifReportHttpError;
  _exports.tryCatchFn = tryCatchFn;
  _exports.Queue = _exports.stringSlice = _exports.canReport = _exports.parseQueryString = _exports.eventTrigger = _exports.getPath = _exports.readXPath = _exports.detailAdapter = _exports.validLog = _exports.clog = _exports.noop = _exports.isDom = _exports._ = _exports.isFunction = _exports.merge = _exports.has = _exports.get = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _splice = _interopRequireDefault(_splice);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _parseFloat2 = _interopRequireDefault(_parseFloat2);
  _reverse = _interopRequireDefault(_reverse);
  _map = _interopRequireDefault(_map);
  _concat = _interopRequireDefault(_concat);
  _indexOf = _interopRequireDefault(_indexOf);
  _forEach = _interopRequireDefault(_forEach);
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _slice = _interopRequireDefault(_slice);
  _assign = _interopRequireDefault(_assign);
  _isArray = _interopRequireDefault(_isArray);
  _reduce = _interopRequireDefault(_reduce);
  _objectSpread2 = _interopRequireDefault(_objectSpread2);
  _filter = _interopRequireDefault(_filter);
  _keys = _interopRequireDefault(_keys);
  _typeof2 = _interopRequireDefault(_typeof2);
  _pako = _interopRequireDefault(_pako);
  _rule = _interopRequireDefault(_rule);
  _jsCookie = _interopRequireDefault(_jsCookie);

  /**
   * 不依赖于lodash，webpack配置按需加载lodash会导致sdk中所有lodash方法运行异常
   * @author wangqiang025@ke.com
   * @created at 2019-07-08
   */
  var toString = Object.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  /**
   * 返回给定value的类型
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  function getTag(value) {
    if (value == null) {
      return value === undefined ? '[object Undefined]' : '[object Null]';
    }

    return toString.call(value);
  }
  /**
   * 判断给定值是不是一个对象
   * @param {*} value
   * @returns {Boolean} 如果是返回 true，否则返回 false
   */


  function isObject(value) {
    var type = (0, _typeof2.default)(value);
    return value != null && (type === 'object' || type === 'function');
  }
  /**
   * 判断给定值是不是一个空对象
   * @param {*} obj
   * @returns {Boolean} 如果是返回 true，否则返回 false
   */


  function isPlainObject(obj) {
    if (isObject(obj)) {
      while ((0, _keys.default)(obj).pop()) {
        return false;
      }

      return true;
    }

    return false;
  }
  /**
   * 根据 object对象的path路径获取值。 如果解析 value 是 undefined 会以 defaultValue 取代。
   * @param {Object} object 要检索的对象
   * @param {Array|string} path 要获取属性的路径
   * @param {*} defaultValue 如果解析值是 undefined ，这值会被返回
   * @return {*}: 返回解析的值
   *
   * @example
   *  var obj = {
   *    name: 'Alex',
   *    job: {
   *      business: 'IT'
   *    },
   *    clothes: [
   *      {
   *         color: 'red',
   *         price: 200
   *      }
   *    ]
   *  };
   *  get(obj, ['job', 'business'], ''); // IT
   *  get(obj, 'clothes.0.color', ''); // 'red'
   *  get(obj, 'clothes.0.test', 'no test'); // 'no test'
   */


  var get = function get(object, path, defaultValue) {
    var _context;

    var _path = getTag(path) === '[object Array]' ? path : (0, _filter.default)(_context = String.prototype.split.call(path, /[,[\].]+?/)).call(_context, Boolean);

    var index = 0;
    var length = _path.length;

    var result = function () {
      while (object != null && index < length) {
        object = object[_path[index++]];
      }

      return index && index == length ? object : undefined;
    }();

    return result === undefined ? defaultValue : result;
  };
  /**
   * 检查 key 是否是object对象的直接属性
   * @param {Object} object 要检索的对象
   * @param {String} key 要检查的 key
   * @returns {boolean} 如果存在，那么返回 true ，否则返回 false
   */


  _exports.get = get;

  var has = function has(object, key) {
    return object != null && hasOwnProperty.call(object, key);
  };
  /**
   * 深度 merge
   * @param {Object} source
   * @param {Object} other
   * @returns {Object} 一个merge后的新对象
   */


  _exports.has = has;

  var merge = function merge(source, other) {
    if (!isObject(source) || !isObject(other)) {
      return other === undefined ? source : other;
    }

    if (isFunction(source) || isFunction(other)) {
      return other === undefined ? source : other;
    } // 合并两个对象的 key，另外要区分数组的初始值为 []


    var keys = (0, _keys.default)((0, _objectSpread2.default)({}, source, other));
    return (0, _reduce.default)(keys).call(keys, function (acc, key) {
      // 递归合并 value
      acc[key] = merge(source[key], other[key]);
      return acc;
    }, (0, _isArray.default)(source) ? [] : {});
  };
  /**
   * 判断给定的value是不是一个function类型
   * @param {*} value
   * @returns {Boolean} 如果是返回 true，否则返回 false
   */


  _exports.merge = merge;

  var isFunction = function isFunction(value) {
    if (!isObject(value)) return false;
    var tag = getTag(value);
    return tag == '[object Function]' || tag == '[object AsyncFunction]' || tag == '[object GeneratorFunction]' || tag == '[object Proxy]';
  }; // 将loadsh的方法集中到_中


  _exports.isFunction = isFunction;

  var _ = (0, _assign.default)({}, {
    get: get,
    has: has,
    isFunction: isFunction,
    merge: merge,
    isPlainObject: isPlainObject,
    isObject: isObject
  });

  _exports._ = _;

  var isDom = function isDom(target) {
    return typeof HTMLElement === 'function' ? target instanceof HTMLElement : target && (0, _typeof2.default)(target) === 'object' && target.nodeType === 1 && typeof target.nodeName === 'string';
  };

  _exports.isDom = isDom;

  var noop = function noop() {};
  /**
   * 生成字符串的hash
   * via https://stackoverflow.com/a/7616484/4197333
   * @param {*} content
   */


  _exports.noop = noop;

  function hash(content) {
    content = content + '';
    var hash = 0;
    var index = 0;
    var charCodeAt = 0;

    if (content.length === 0) {
      return hash.toString(36);
    }

    for (index = 0; index < content.length; index++) {
      // 每一位字符的utf-8编码
      charCodeAt = content.charCodeAt(index);
      hash = (hash << 5) - hash + charCodeAt;
      hash |= 0; // Convert to 32bit integer
    }

    return hash.toString(36);
  }

  function getUUID() {
    var timestampMs = new Date() * 1;

    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(36).substring(1);
    }

    return hash(timestampMs + '') + '-' + hash(navigator.userAgent) + '-' + s4() + s4() + s4() + s4() + s4() + '-' + s4() + s4() + s4();
  }

  function parseDomain(hostname) {
    // 首先用比较严肃的方法:
    // 先尝试匹配常见后缀
    var checkReg = new RegExp(/(.*?)\.?([^.]*?)\.(gl|com|net|org|biz|ws|in|me|co\.uk|co|org\.uk|ltd\.uk|plc\.uk|me\.uk|edu|mil|br\.com|cn\.com|eu\.com|hu\.com|no\.com|qc\.com|sa\.com|se\.com|se\.net|us\.com|uy\.com|ac|co\.ac|gv\.ac|or\.ac|ac\.ac|af|am|as|at|ac\.at|co\.at|gv\.at|or\.at|asn\.au|com\.au|edu\.au|org\.au|net\.au|id\.au|be|ac\.be|adm\.br|adv\.br|am\.br|arq\.br|art\.br|bio\.br|cng\.br|cnt\.br|com\.br|ecn\.br|eng\.br|esp\.br|etc\.br|eti\.br|fm\.br|fot\.br|fst\.br|g12\.br|gov\.br|ind\.br|inf\.br|jor\.br|lel\.br|med\.br|mil\.br|net\.br|nom\.br|ntr\.br|odo\.br|org\.br|ppg\.br|pro\.br|psc\.br|psi\.br|rec\.br|slg\.br|tmp\.br|tur\.br|tv\.br|vet\.br|zlg\.br|br|ab\.ca|bc\.ca|mb\.ca|nb\.ca|nf\.ca|ns\.ca|nt\.ca|on\.ca|pe\.ca|qc\.ca|sk\.ca|yk\.ca|ca|cc|ac\.cn|com\.cn|edu\.cn|gov\.cn|org\.cn|bj\.cn|sh\.cn|tj\.cn|cq\.cn|he\.cn|nm\.cn|ln\.cn|jl\.cn|hl\.cn|js\.cn|zj\.cn|ah\.cn|gd\.cn|gx\.cn|hi\.cn|sc\.cn|gz\.cn|yn\.cn|xz\.cn|sn\.cn|gs\.cn|qh\.cn|nx\.cn|xj\.cn|tw\.cn|hk\.cn|mo\.cn|cn|cx|cz|de|dk|fo|com\.ec|tm\.fr|com\.fr|asso\.fr|presse\.fr|fr|gf|gs|co\.il|net\.il|ac\.il|k12\.il|gov\.il|muni\.il|ac\.in|co\.in|org\.in|ernet\.in|gov\.in|net\.in|res\.in|is|it|ac\.jp|co\.jp|go\.jp|or\.jp|ne\.jp|ac\.kr|co\.kr|go\.kr|ne\.kr|nm\.kr|or\.kr|li|lt|lu|asso\.mc|tm\.mc|com\.mm|org\.mm|net\.mm|edu\.mm|gov\.mm|ms|nl|no|nu|pl|ro|org\.ro|store\.ro|tm\.ro|firm\.ro|www\.ro|arts\.ro|rec\.ro|info\.ro|nom\.ro|nt\.ro|se|si|com\.sg|org\.sg|net\.sg|gov\.sg|sk|st|tf|ac\.th|co\.th|go\.th|mi\.th|net\.th|or\.th|tm|to|com\.tr|edu\.tr|gov\.tr|k12\.tr|net\.tr|org\.tr|com\.tw|org\.tw|net\.tw|ac\.uk|uk\.com|uk\.net|gb\.com|gb\.net|vg|sh|kz|ch|info|ua|gov|name|pro|ie|hk|com\.hk|org\.hk|net\.hk|edu\.hk|us|tk|cd|by|ad|lv|eu\.lv|bz|es|jp|cl|ag|mobi|eu|co\.nz|org\.nz|net\.nz|maori\.nz|iwi\.nz|io|la|md|sc|sg|vc|tw|travel|my|se|tv|pt|com\.pt|edu\.pt|asia|fi|com\.ve|net\.ve|fi|org\.ve|web\.ve|info\.ve|co\.ve|tel|im|gr|ru|net\.ru|org\.ru|hr|com\.hr|ly|xyz)$/);
    var parseResult = hostname.match(checkReg);
    var domain;

    if (parseResult) {
      domain = parseResult[2] ? parseResult[2] + '.' + parseResult[3] : undefined;
    }

    if (domain === undefined) {
      // 没有匹配到常见后缀, 则使用最后两段被.分隔的字符, 作为主域名
      var urlSplitList = hostname.split('.');
      domain = (0, _slice.default)(urlSplitList).call(urlSplitList, urlSplitList.length - 2, urlSplitList.length).join('.');
    } // 强制转为字符串


    domain = domain + '';
    return domain;
  }

  function getDeviceId() {
    // 尝试在cookie中获取
    var deviceId = _jsCookie.default.get(_constant.COOKIE_NAME_DIVICE_ID);

    if (deviceId === undefined) {
      // cookie中也没有, 手工设置上
      deviceId = getUUID();
      var hostname = location.hostname;
      var domain = parseDomain(hostname); // cookie需要种在主域名上, 否则像bj.ke.com/sh.ke.com下的设备数就炸了

      _jsCookie.default.set(_constant.COOKIE_NAME_DIVICE_ID, deviceId, {
        expires: 1000,
        domain: domain
      }); // Cookie有可能种失败, 如果接种失败, 则还是返回空字符串


      deviceId = _jsCookie.default.get(_constant.COOKIE_NAME_DIVICE_ID) || '';
    }

    return deviceId;
  }

  function customerErrorCheck(_x) {
    return _customerErrorCheck.apply(this, arguments);
  }

  function _customerErrorCheck() {
    _customerErrorCheck = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee(commonConfig) {
      var debugLogger,
          errorLog,
          type,
          desc,
          stack,
          reason,
          message,
          customerErrorCheckFunc,
          errorType,
          isNeedReport,
          _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              debugLogger = _args.length > 1 && _args[1] !== undefined ? _args[1] : console.log;
              errorLog = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              type = errorLog.type, desc = errorLog.desc, stack = errorLog.stack, reason = errorLog.reason, message = errorLog.message; // 调用自定义函数, 检测是否需要上报错误

              customerErrorCheckFunc = _.get(commonConfig, ['record', 'js_error_report_config', 'checkErrorNeedReport'], '');

              if (_.isFunction(customerErrorCheckFunc) === false) {
                // 之前配置项写错了, 写成了checkErrrorNeedReport(多写了一个r), 所以要兼容一下
                customerErrorCheckFunc = _.get(commonConfig, ['record', 'js_error_report_config', 'checkErrrorNeedReport'], _.get(_constant.DEFAULT_CONFIG, ['record', 'js_error_report_config', 'checkErrorNeedReport']));
              }

              errorType = _constant.JS_TRACKER_ERROR_DISPLAY_MAP[type];
              isNeedReport = false;
              _context7.prev = 7;
              _context7.next = 10;
              return customerErrorCheckFunc(desc, stack, reason, message, errorType);

            case 10:
              isNeedReport = _context7.sent;
              _context7.next = 17;
              break;

            case 13:
              _context7.prev = 13;
              _context7.t0 = _context7["catch"](7);
              debugLogger("config.record.js_error_report_config.checkErrorNeedReport\u6267\u884C\u65F6\u53D1\u751F\u5F02\u5E38, \u8BF7\u6CE8\u610F, \u9875\u9762\u62A5\u9519\u4FE1\u606F\u4E3A=>", {
                e: _context7.t0,
                desc: desc,
                stack: stack
              });
              isNeedReport = true;

            case 17:
              return _context7.abrupt("return", isNeedReport);

            case 18:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee, this, [[7, 13]]);
    }));
    return _customerErrorCheck.apply(this, arguments);
  }

  var clog = function clog(text) {
    console.log("%c ".concat(text), 'color:red');
  };

  _exports.clog = clog;

  var validLog = function validLog(commonConfig) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var code = arguments.length > 2 ? arguments[2] : undefined;
    var detail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var extra = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    var pid = _.get(commonConfig, ['pid'], '');

    if (!pid) {
      return '请设置工程ID[pid]';
    }

    if (type === 'error') {
      if (code < 0 || code > 9999) {
        return 'type:error的log code 应该在1～9999之间';
      }
    } else if (type === 'product') {
      if (code < 10000 || code > 19999) {
        return 'type:product的log code 应该在10000～19999之间';
      }
    } else if (type === 'info') {
      if (code < 20000 || code > 29999) {
        return 'type:info的log code 应该在20000～29999之间';
      }
    } // 字端段类型校验


    if ((0, _typeof2.default)(detail) !== 'object') {
      return 'second argument detail required object';
    } // 字端段类型校验


    if ((0, _typeof2.default)(extra) !== 'object') {
      return 'third argument extra required object';
    } // 字段校验


    var ruleItem = _rule.default[code];

    if (ruleItem) {
      // 消费字段必填
      var requireFields = (0, _toConsumableArray2.default)(ruleItem.df);
      var realFields = (0, _keys.default)(detail);
      var needFields = [];
      (0, _forEach.default)(requireFields).call(requireFields, function (field) {
        // 缺字端
        if ((0, _indexOf.default)(realFields).call(realFields, field) === -1) {
          needFields.push(field);
        }
      });

      if (needFields.length) {
        var _context2;

        return (0, _concat.default)(_context2 = "code: ".concat(code, " \u8981\u6C42 ")).call(_context2, needFields.join(','), "\u5B57\u6BB5\u5FC5\u586B");
      }
    }

    return '';
  };

  _exports.validLog = validLog;

  var detailAdapter = function detailAdapter(code) {
    var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var dbDetail = {
      error_no: '',
      http_code: '',
      during_ms: '',
      url: '',
      request_size_b: '',
      response_size_b: ''
    }; // 查找rule

    var ruleItem = _rule.default[code];

    if (ruleItem) {
      var d = (0, _objectSpread2.default)({}, dbDetail);
      var fields = (0, _keys.default)(detail);
      (0, _forEach.default)(fields).call(fields, function (field) {
        var transferField = ruleItem.dft[field]; // 需要字段转换

        if (transferField) {
          // 需要字段转换
          d[transferField] = detail[field];
          delete detail[field];
        } else {
          d[field] = detail[field];
        }
      });
      return d;
    } else {
      return detail;
    }
  };

  _exports.detailAdapter = detailAdapter;

  var readXPath = function readXPath(element) {
    var ix = 1;
    var nodeName = element.nodeName;
    var tagName = element.tagName;
    var parentNode = element.parentNode;
    var siblings = parentNode.childNodes;

    if (nodeName === 'BODY' || nodeName === 'HEAD') {
      return '/html/' + tagName.toLowerCase();
    }

    for (var i = 0, l = siblings.length; i < l; i++) {
      var sibling = siblings[i];

      if (sibling === element) {
        return readXPath(element.parentNode) + '/' + tagName.toLowerCase() + '[' + ix + ']';
      } else if (sibling.nodeType === 1 && sibling.tagName === tagName) {
        ix++;
      }
    }
  };

  _exports.readXPath = readXPath;

  var getPath = function getPath() {
    var _context3;

    var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (!(0, _isArray.default)(paths)) return '';
    var path = (0, _map.default)(_context3 = (0, _slice.default)(paths).call(paths, 0, -2)).call(_context3, function (element) {
      var _context4, _context5;

      var id = element.id;
      var name = element.tagName.toLowerCase();
      var className = element.getAttribute('class');
      if (id) return (0, _concat.default)(_context4 = "".concat(name, "#")).call(_context4, id);
      if (className) return (0, _concat.default)(_context5 = "".concat(name, ".")).call(_context5, className);
      return name;
    }, '');
    return (0, _reverse.default)(path).call(path).join();
  };

  _exports.getPath = getPath;

  var eventTrigger = function eventTrigger(event) {
    var e = new CustomEvent(event, {
      detail: this
    });
    window.dispatchEvent(e);
  };

  _exports.eventTrigger = eventTrigger;

  var parseQueryString = function parseQueryString(url) {
    var json = {};
    var index = (0, _indexOf.default)(url).call(url, '?');
    if (!~index) return null;
    var arr = url.substr(index + 1).split('&');
    (0, _forEach.default)(arr).call(arr, function (item) {
      var tmp = item.split('=');
      json[tmp[0]] = tmp[1];
    });
    return json;
  };
  /**
   *  采样方法
   * @param {number} key
   * @return {?}
   */


  _exports.parseQueryString = parseQueryString;

  var canReport = function canReport(key) {
    return !!key && key !== 0 && (key >= 1 || key === '100%' || (/^\d+(\.\d+)?%$/.test(key) ? Math.random() < (0, _parseFloat2.default)(key) / 100 : key > 0 && key < 1 && Math.random() < key));
  };
  /**
   * 字符串截取
   *
   * @param {*} str
   * @param {*} len
   * @param {string} [padding='']
   * @returns
   */


  _exports.canReport = canReport;

  var stringSlice = function stringSlice(str, len) {
    var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    if (!str) return '';

    if (typeof str !== 'string') {
      str = Object.prototype.toString.call(str);
    }

    if (!len) return str + padding;
    return (0, _slice.default)(str).call(str, 0, len) + padding;
  };

  _exports.stringSlice = stringSlice;

  function gzip(source) {
    return _pako.default.deflate(source, {
      to: 'string'
    });
  }

  function ifReportHttpError(status, url) {
    return !(status === 0 && /^file:\/\/\//.test(url) || /^2\d\d$/.test(status));
  }

  function tryCatchFn(fn) {
    var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return function () {
      try {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return fn.apply(ctx, args);
      } catch (e) {
        console.warn(e);
      }
    };
  }

  var Queue =
  /*#__PURE__*/
  function () {
    function Queue() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      (0, _classCallCheck2.default)(this, Queue);
      this.data = data;
    }

    (0, _createClass2.default)(Queue, [{
      key: "enqueue",
      // 事件入队
      value: function enqueue(record) {
        this.data.push(record);
      } // 删除index位置的元素

    }, {
      key: "deleteOne",
      value: function deleteOne(index) {
        var _context6;

        if (index < 0 || index > this.size) return;
        (0, _splice.default)(_context6 = this.data).call(_context6, index, 1);
      } // 出队

    }, {
      key: "dequeue",
      value: function dequeue() {
        this.data.shift();
      } // 清空队列

    }, {
      key: "clearQueue",
      value: function clearQueue() {
        this.data = [];
      }
    }, {
      key: "size",
      get: function get() {
        return this.data.length;
      }
    }]);
    return Queue;
  }();

  _exports.Queue = Queue;
});